module.exports = __webpack_public_path__ + "static/media/25.146b5e47.mp3";